import { Wrench, ShieldCheck, LifeBuoy, Home } from 'lucide-react';
import CTA from '../Cta';
import GasStoveImg from '../../img/Gas-stove-service-img.png'

function GasStoveRepairService() {
    return (
        <div className="chimney-repair-container">
            {/* Hero Section - No content, just introductory information */}
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Expert Gas Stove Repair Services</h1>
                    <p className="chimney-repair-subtitle">
                        Our expert gas stove repair services are designed to restore the performance of your gas stove, ensuring it operates safely and efficiently. Whether it's a burner issue, gas leak, or ignition problem, we are here to help maintain the safety of your kitchen. Gas stove problems, if left unchecked, can lead to safety hazards and inefficient cooking.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Trust our certified technicians to provide reliable and affordable gas stove repair services, tailored to meet the specific needs of your kitchen. From inspection to repair and maintenance, we deliver comprehensive gas stove solutions, guaranteeing long-lasting performance and safety.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Regular maintenance and timely repairs can significantly extend the life of your gas stove and prevent costly damage. We offer full-service repairs including burner cleaning, replacement of faulty parts, and the restoration of your stove’s functionality. Our team is equipped with the latest tools and knowledge to handle all gas stove-related issues.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Don't wait for a problem to escalate. Our gas stove services are designed to address even the smallest issues before they become major concerns. Let us help you keep your kitchen safe, efficient, and ready for cooking with our expert gas stove repair services.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:70390 34000")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={GasStoveImg} alt="Gas Stove Repair" />
            </div>

            {/* Section 1: Why Choose Us */}
            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Gas Stove Repair Service?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Wrench size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Skilled Technicians</h3>
                            <p className="chimney-repair-description">
                                Our technicians are experts trained in the latest gas stove repair techniques.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Safety First</h3>
                            <p className="chimney-repair-description">
                                We prioritize safety—ensuring your gas stove repair adheres to all safety standards.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <LifeBuoy size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Emergency Repairs</h3>
                            <p className="chimney-repair-description">
                                Available 24/7 to fix any urgent gas stove issues and restore your kitchen’s comfort.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Home size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Affordable Solutions</h3>
                            <p className="chimney-repair-description">
                                We offer cost-effective repair options without compromising on quality.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: Our Process */}
            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Gas Stove Repair Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Our team conducts a thorough inspection to diagnose the issue and recommend the best solution for your gas stove.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Repair Plan</h3>
                        <p className="chimney-repair-step-description">
                            We provide you with a clear repair plan and cost estimate, ensuring transparency and no hidden fees.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Efficient Repair</h3>
                        <p className="chimney-repair-step-description">
                            Our skilled technicians repair your gas stove quickly, with minimal disruption to your daily routine.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Final Check</h3>
                        <p className="chimney-repair-step-description">
                            We complete a final check to ensure your gas stove is operating safely and efficiently.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default GasStoveRepairService;
